// extracted by mini-css-extract-plugin
export default {"settings":"SettingsForm-module--settings--7McVT","likes-limit-input":"SettingsForm-module--likes-limit-input--QH5Lu","likes-container":"SettingsForm-module--likes-container--ZdJib"};